"use client";
/*
 * Documentation:
 * TagScore — https://app.subframe.com/ae91faa555e6/library?component=TagScore_f095d986-fcff-45c4-b01e-15a40a38bdd2
 */

import React from "react";
import * as SubframeUtils from "../utils";
import * as SubframeCore from "@subframe/core";

interface TagScoreRootProps extends React.HTMLAttributes<HTMLDivElement> {
  text?: React.ReactNode;
  variant?: "default" | "low" | "medium" | "high" | "plain" | "txt";
  className?: string;
}

const TagScoreRoot = React.forwardRef<HTMLElement, TagScoreRootProps>(
  function TagScoreRoot(
    { text, variant = "default", className, ...otherProps }: TagScoreRootProps,
    ref
  ) {
    return (
      <div
        className={SubframeUtils.twClassNames(
          "group/f095d986 flex items-center gap-2",
          {
            "bg-neutral-100": variant === "txt",
            "bg-transparent": variant === "plain",
          },
          className
        )}
        ref={ref as any}
        {...otherProps}
      >
        <div
          className={SubframeUtils.twClassNames(
            "flex h-6 items-center gap-1 rounded-md border border-solid border-neutral-border bg-neutral-50 px-2",
            {
              "border border-solid border-neutral-300 bg-neutral-100":
                variant === "txt",
              "bg-transparent": variant === "plain",
              "border border-solid border-success-100 bg-success-50":
                variant === "high",
              "border border-solid border-warning-100 bg-warning-50":
                variant === "medium",
              "border border-solid border-error-100 bg-error-50":
                variant === "low",
            }
          )}
        >
          <SubframeCore.Icon
            className="text-label font-label text-error-700"
            name={null}
          />
          {text ? (
            <span
              className={SubframeUtils.twClassNames(
                "whitespace-nowrap text-label font-label text-subtext-color",
                {
                  "text-body font-body text-default-font": variant === "txt",
                  "text-label-bold font-label-bold text-default-font":
                    variant === "plain",
                  "text-success-800": variant === "high",
                  "text-warning-800": variant === "medium",
                  "text-error-800": variant === "low",
                }
              )}
            >
              {text}
            </span>
          ) : null}
          <SubframeCore.Icon
            className="text-label font-label text-error-700"
            name={null}
          />
        </div>
      </div>
    );
  }
);

export const TagScore = TagScoreRoot;
